module.exports = __webpack_public_path__ + "img/font-solid.a50798a0.svg";